<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>
      PSI Phonebook
    </ion-title>
    <img alt="PSI logo" slot="end" class="titleicon" [src]="assets + '/psi_logo.svg'" width="80px" routerLink="/home" />
  </ion-toolbar>
</ion-header>

<!--Input of the query-->
<form [formGroup]="searchForm">
  <ion-searchbar type="text" animated placeholder="Search a person or number" formControlName="search"
    (ionChange)="nextQuery()">
  </ion-searchbar>
</form>

<ion-content class="ion-padding">

  <div *ngIf="searchForm.controls['search'].value.length > 2 && proposalList">
    <div *ngFor="let user of proposalList">
      <div *ngIf="user.phone && user.email">

        <!--Internal Contact-->
        <ion-card *ngIf="isInternal(user)">
          <ion-card-header>
            <ion-card-subtitle>Paul Scherrer Institute</ion-card-subtitle>
            <ion-card-title>
              {{user.fullName}}
            </ion-card-title>
          </ion-card-header>
          <ion-card-content>
            <a title="Mail to {{user.fullName}}" *ngIf="user.email" href="#" (click)="openEmail(user.email)">
              <ion-chip color="dark">
                <ion-icon name="mail"></ion-icon>
                <ion-label class="ion-text-lowercase">{{user.email}}</ion-label>
              </ion-chip>
            </a>
            <a title="Phone to {{user.fullName}}" *ngIf="user.phone" href="tel:{{user.phone}}">
              <ion-chip color="dark">
                <ion-icon name="call"></ion-icon>
                <ion-label>{{user.phone.substring(0,11)}}<b>{{user.phone.substring(11,17)}}</b></ion-label>
              </ion-chip>
            </a>
          </ion-card-content>
        </ion-card>
        <!--External Contacts-->
        <ion-card class="ext-card" *ngIf="!isInternal(user)">
          <ion-card-header>
            <ion-card-subtitle>External</ion-card-subtitle>
            <ion-card-title>
              {{user.fullName}}
            </ion-card-title>
          </ion-card-header>
          <ion-card-content>
            <a title="Send email to {{user.fullName}}" *ngIf="user.email" href="#" (click)="openEmail(user.email)">
              <ion-chip color="dark">
                <ion-icon name="mail"></ion-icon>
                <ion-label>{{user.email}}</ion-label>
              </ion-chip>
            </a>
            <a title="Phone to {{user.fullName}}" *ngIf="user.phone" href="tel:{{user.phone}}">
              <ion-chip color="dark">
                <ion-icon name="call"></ion-icon>
                <ion-label>{{user.phone}}</ion-label>
              </ion-chip>
            </a>
          </ion-card-content>
        </ion-card>
      </div>
      </div>
    </div>
    <div *ngIf="proposalList?.length == 0">
      No search results found.
    </div>
</ion-content>
